import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Initialize anonymous session if no session exists
export const initializeAnonUser = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      // Try to sign in anonymously
      const { data, error } = await supabase.auth.signInWithPassword({
        email: 'anonymous@jarvis.ai',
        password: 'anonymous123'
      });
      
      if (error) {
        console.error('Erro ao fazer login anônimo:', error);
        // If login fails, try to create the anonymous user
        const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
          email: 'anonymous@jarvis.ai',
          password: 'anonymous123'
        });
        
        if (signUpError) {
          console.error('Erro ao criar usuário anônimo:', signUpError);
        }
        return signUpData.user;
      }
      
      return data.user;
    }
    
    return session.user;
  } catch (error) {
    console.error('Erro ao inicializar usuário:', error);
    return null;
  }
};

// Helper functions for type safety
export const getUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) {
    // If there's an error getting the user, try to initialize anonymous session
    return await initializeAnonUser();
  }
  return user || await initializeAnonUser();
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
  // After signing out, initialize anonymous session
  await initializeAnonUser();
};

// Tipos úteis
export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[];

export interface Database {
  public: {
    Tables: {
      calendar_events: {
        Row: {
          id: string;
          created_at: string;
          updated_at: string;
          title: string;
          description: string | null;
          start_time: string;
          end_time: string;
          category: string;
          location: string | null;
          user_id: string;
          is_all_day: boolean;
          is_recurring: boolean;
          recurrence_rule: string | null;
          reminder_minutes: number[] | null;
          color: string | null;
        };
        Insert: {
          id?: string;
          created_at?: string;
          updated_at?: string;
          title: string;
          description?: string | null;
          start_time: string;
          end_time: string;
          category: string;
          location?: string | null;
          user_id: string;
          is_all_day?: boolean;
          is_recurring?: boolean;
          recurrence_rule?: string | null;
          reminder_minutes?: number[] | null;
          color?: string | null;
        };
        Update: {
          id?: string;
          created_at?: string;
          updated_at?: string;
          title?: string;
          description?: string | null;
          start_time?: string;
          end_time?: string;
          category?: string;
          location?: string | null;
          user_id?: string;
          is_all_day?: boolean;
          is_recurring?: boolean;
          recurrence_rule?: string | null;
          reminder_minutes?: number[] | null;
          color?: string | null;
        };
      };
    };
  };
}
